import { shortLabel } from "./labels";

export default function OperatorsTable({ operators, types, selectedId, officeLabel }) {
  const sum = (k) => operators.reduce((s, o) => s + o[k], 0);
  const sumType = (code) => operators.reduce((s, o) => s + (o.by_type[code] || 0), 0);
  return (
    <div className="overflow-x-auto rounded-lg border border-border" data-testid="operators-table-wrap">
      <div className="flex flex-wrap items-center justify-between gap-2 px-2 py-1.5 text-xs">
        <span className="font-semibold text-slate-700">Dettaglio operatori — {officeLabel}</span>
        <span className="text-slate-500">Ogni registrazione conta una sola volta: la riga Totale sede è la somma degli operatori.</span>
      </div>
      <table className="w-full text-xs" data-testid="operators-table">
        <thead className="bg-slate-50 text-left text-slate-500">
          <tr><th className="sticky left-0 z-10 bg-slate-50 px-2 py-1.5">Operatore</th><th className="px-2 py-1.5">Sede</th><th className="px-2 py-1.5">Ingressi</th>
            {types.map((t) => <th key={t.code} className="px-2 py-1.5 whitespace-nowrap">{shortLabel(t)}</th>)}
            <th className="px-2 py-1.5">Totale op.</th><th className="px-2 py-1.5">Contr./Ingr.</th></tr>
        </thead>
        <tbody>
          {operators.length === 0 && <tr><td colSpan={types.length + 5} className="px-2 py-3 text-center text-slate-400">Nessun operatore nel perimetro.</td></tr>}
          {operators.map((o) => (
            <tr key={o.operator_id} className={`border-t border-slate-100 ${selectedId === o.operator_id ? "bg-brand/5 font-semibold" : ""}`} data-testid={`operator-row-${o.operator_id}`}>
              <td className={`sticky left-0 z-10 px-2 py-1.5 text-slate-800 ${selectedId === o.operator_id ? "bg-slate-50" : "bg-white"}`}>{o.operator_name}</td><td className="px-2 py-1.5 text-slate-500">{o.office_name || "—"}</td>
              <td className="px-2 py-1.5" data-testid={`operator-visits-${o.operator_id}`}>{o.visits}</td>
              {types.map((t) => <td key={t.code} className="px-2 py-1.5" data-testid={`operator-${t.code}-${o.operator_id}`}>{o.by_type[t.code]}</td>)}
              <td className="px-2 py-1.5 font-semibold" data-testid={`operator-total-${o.operator_id}`}>{o.total_operations}</td>
              <td className="px-2 py-1.5">{o.conversion_percent == null ? "—" : `${o.conversion_percent}%`}</td>
            </tr>
          ))}
          {operators.length > 0 && (
            <tr className="border-t-2 border-slate-300 bg-slate-50 font-bold text-slate-800" data-testid="operators-total-row">
              <td className="sticky left-0 z-10 bg-slate-50 px-2 py-1.5" colSpan={2}>Totale {officeLabel}</td>
              <td className="px-2 py-1.5" data-testid="operators-total-visits">{sum("visits")}</td>
              {types.map((t) => <td key={t.code} className="px-2 py-1.5" data-testid={`operators-total-${t.code}`}>{sumType(t.code)}</td>)}
              <td className="px-2 py-1.5" data-testid="operators-total-operations">{sum("total_operations")}</td>
              <td className="px-2 py-1.5">{sum("visits") ? `${Math.round(sum("goal_operations") * 1000 / sum("visits")) / 10}%` : "—"}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
